import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca05c84a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ca05c84a&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=ca05c84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca05c84a",
  null
  
)

component.options.__file = "index.vue"
export default component.exports